import { TableCell, TableHead, TableRow } from "@mui/material";
import PrescriptionSubmittedCellHeader from "@pages/CommandCenter/CommandCenterTable/Cells/PrescriptionSubmittedCellHeader";
import StickyTableCellHeader from "@pages/CommandCenter/CommandCenterTable/Cells/StickyTableCellHeader";

const DosiTableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <StickyTableCellHeader width="19%">Patient</StickyTableCellHeader>
        <TableCell width="10%">Site & Physician</TableCell>
        <PrescriptionSubmittedCellHeader />
        <TableCell width="19%">Careplan</TableCell>
        <TableCell>Planning Status</TableCell>
        <TableCell width="14%">Assigned to</TableCell>
        <TableCell width="7%">{/** Comment Button */}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default DosiTableHeader;
